export type LocaleValue = 'de-DE' | 'fr-FR' | 'en' | 'de-CH';

export type LanguageCode = 'de' | 'fr' | 'en' | 'tu';

export type MarketCode = 'DE' | 'FR' | 'CH';
export const ALLOWED_MARKETS = ['DE', 'FR', 'CH'];
